import React from "react";
import LivePrices from "../pages/LivePrices";
import Features from "../components/Features";
import AltinSlider from "../components/AltinSlider";
import Aratext from "../components/aratext";

const Home: React.FC = () => {
  return (
    <div>
      <LivePrices />
      <Aratext />
      <AltinSlider />
      
    </div>
  );
};

export default Home;
